/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { AdSlotRow } from "./ad-slot-row";
import { CustomWidgetRow } from "./custom-widget-row";
import { AuthorsListComponent } from "../pages/authors-list";

import {
  ThreeColGrid as ArrowThreeColGrid,
  FourColGrid as ArrowFourColGrid,
  ElevenStories as ArrowElevenStories,
  OneColStoryList as ArrowOneColStoryList,
  TwoColThreeStories as ArrowTwoColThreeStories,
  ThreeColSixStories as ArrowThreeColSixStories,
  TwoColFourStories as ArrowTwoColFourStories,
  ThreeColSevenStory as ArrowThreeColSevenStory,
  CollectionFilter as ArrowCollectionFilter,
  IntroductionCard as ArrowIntroductionCard,
  AuthorIntroductionCard as ArrowAuthorIntroductionCard,
  HalfScreenSlider as ArrowHalfScreenSlider,
  FullScreenSlider as ArrowFullScreenSlider,
  FourStorySlider as ArrowFourStorySlider,
  PageIntroductionCard as ArrowPageIntroductionCard,
  MagazineHeaderCard as ArrowMagazineHeaderCard,
  MagazineEditions as ArrowMagazineEditions,
  MagazineWidget as ArrowMagazineWidget,
  TwoColSixStories as ArrowTwoColSixStories,
  OpinionCollection as ArrowOpinionCollection,
  TwoColFourStoryHighlight as ArrowTwoColFourStoryHighlight,
  FourColSixteenStories as ArrowFourColSixteenStories,
  FourColFiveStories as ArrowFourColFiveStories,
  ThreeColFlexStories as ArrowThreeColFlexStories,
  SixColSixStories as ArrowSixColSixStories,
  TwoColTenStoriesSidebar as ArrowTwoColTenStoriesSidebar,
  ThreeColTwelveStories as ArrowThreeColTwelveStories,
  FourColPortraitStories as ArrowFourColPortraitStories,
  AstrologyCollection as ArrowAstrologyCollection
} from "@quintype/arrow";

import { PageIntroduction } from "../molecules/introduction-card";
import { arrowWrapper } from "./arrow";
import SearchPageLayout from "../pages/search-page/search-layout";
import WithSubsequentLoad from "../hoc-components/with-subsequent-load";

// setting max story limit for arrow components
const wrapperForStoryLimits = (Component, storyLimit = 16, nestedCollectionLimit = null) => {
  const arrowWrapperWithStoryCollectionLimits = arrowWrapper(Component);

  arrowWrapperWithStoryCollectionLimits.storyLimit = storyLimit;
  if (nestedCollectionLimit) {
    arrowWrapperWithStoryCollectionLimits.nestedCollectionLimit = nestedCollectionLimit;
  }

  return arrowWrapperWithStoryCollectionLimits;
};

export default {
  ArrowCollectionFilter: wrapperForStoryLimits(ArrowCollectionFilter, 11),
  ArrowThreeColGrid: wrapperForStoryLimits(WithSubsequentLoad(ArrowThreeColGrid, 3, false, true), 6),
  ArrowFourColGrid: wrapperForStoryLimits(WithSubsequentLoad(ArrowFourColGrid, 4, false, true), 8),
  ArrowFourColFiveStories: wrapperForStoryLimits(WithSubsequentLoad(ArrowFourColFiveStories, 5, false, true), 8),
  ArrowOneColStoryList: wrapperForStoryLimits(WithSubsequentLoad(ArrowOneColStoryList, 6, false, true), 9),
  ArrowSixColSixStories: wrapperForStoryLimits(WithSubsequentLoad(ArrowSixColSixStories, 6, false, true), 9),
  ArrowThreeColFlexStories: wrapperForStoryLimits(WithSubsequentLoad(ArrowThreeColFlexStories, 12, false, true), 15),
  ArrowOpinionCollection: wrapperForStoryLimits(WithSubsequentLoad(ArrowOpinionCollection, 6, false, true), 9),
  ArrowFourColPortraitStories: wrapperForStoryLimits(
    WithSubsequentLoad(ArrowFourColPortraitStories, 4, false, true),
    7
  ),
  ArrowThreeColSixStories: wrapperForStoryLimits(ArrowThreeColSixStories, 9),
  ArrowTwoColThreeStories: wrapperForStoryLimits(ArrowTwoColThreeStories, 6),
  ArrowElevenStories: wrapperForStoryLimits(ArrowElevenStories, 14),
  ArrowTwoColFourStories: wrapperForStoryLimits(ArrowTwoColFourStories, 7),
  ArrowHalfScreenSlider: wrapperForStoryLimits(ArrowHalfScreenSlider, 6),
  ArrowFullScreenSlider: wrapperForStoryLimits(ArrowFullScreenSlider, 6),
  ArrowFourStorySlider: wrapperForStoryLimits(ArrowFourStorySlider, 11),
  ArrowThreeColSevenStory: wrapperForStoryLimits(ArrowThreeColSevenStory, 10),
  ArrowIntroductionCard: PageIntroduction(ArrowIntroductionCard),
  ArrowAuthorIntroductionCard: PageIntroduction(ArrowAuthorIntroductionCard),
  ArrowPageIntroductionCard: PageIntroduction(ArrowPageIntroductionCard),
  AuthorsListComponent: wrapperForStoryLimits(AuthorsListComponent, 9),
  ArrowMagazineHeaderCard: arrowWrapper(ArrowMagazineHeaderCard),
  ArrowMagazineEditions: arrowWrapper(ArrowMagazineEditions),
  ArrowMagazineWidget: wrapperForStoryLimits(ArrowMagazineWidget, 7),
  ArrowTwoColSixStories: wrapperForStoryLimits(ArrowTwoColSixStories, 9),
  ArrowTwoColFourStoryHighlight: wrapperForStoryLimits(ArrowTwoColFourStoryHighlight, 7),
  ArrowFourColSixteenStories: wrapperForStoryLimits(ArrowFourColSixteenStories, 7, [7, 7, 7, 7]),
  ArrowTwoColTenStoriesSidebar: wrapperForStoryLimits(ArrowTwoColTenStoriesSidebar, 5, [8, 11]),
  ArrowThreeColTwelveStories: wrapperForStoryLimits(ArrowThreeColTwelveStories, 6, [7, 7, 7]),
  ArrowAstrologyCollection: arrowWrapper(ArrowAstrologyCollection),
  PurchasePageIntroductionCard: PageIntroduction(ArrowPageIntroductionCard),
  Leaderboard: AdSlotRow,
  SuperLeaderboard: AdSlotRow,
  Billboard: AdSlotRow,
  Custom: AdSlotRow,
  widget: CustomWidgetRow,
  SearchPage: SearchPageLayout,
  defaultTemplate: wrapperForStoryLimits(WithSubsequentLoad(ArrowThreeColGrid, 3, false, true), 6)
};
